// components/admin/accounting/modals/ImageUploadModal.jsx
import React from 'react';
import { X, Image as ImageIcon } from 'lucide-react';

function ImageUploadModal({
  isOpen,
  selectedFiles,
  previewUrls,
  isUploading,
  dragActive,
  onClose,
  onFileSelect,
  onDrag,
  onDrop,
  onPaste,
  onRemoveFile,
  onUpload
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-slate-200 p-6">
          <div className="flex items-center justify-between">
            <h3 className="text-xl font-bold text-slate-800 font-montserrat">
              Subir Comprobantes de Pago
            </h3>
            <button
              onClick={onClose}
              className="text-slate-400 hover:text-slate-600 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="p-6">
          {/* Drop Zone */}
          <div
            className={`
              border-2 border-dashed rounded-lg p-8 text-center transition-all
              ${dragActive
                ? 'border-brand-primary bg-brand-primary/5'
                : 'border-slate-300 hover:border-brand-primary'
              }
            `}
            onDragEnter={onDrag}
            onDragLeave={onDrag}
            onDragOver={onDrag}
            onDrop={onDrop}
            onPaste={onPaste}
            tabIndex={0}
          >
            <ImageIcon className="w-16 h-16 mx-auto mb-4 text-slate-400" />
            <p className="text-lg font-semibold text-slate-700 mb-2 font-montserrat">
              Arrastra imágenes aquí
            </p>
            <p className="text-sm text-slate-500 mb-4 font-montserrat">
              o pega (Ctrl+V) una captura de pantalla
            </p>
            <label className="inline-block">
              <input
                type="file"
                multiple
                accept="image/*"
                onChange={onFileSelect}
                className="hidden"
              />
              <span className="px-6 py-3 bg-brand-primary text-white rounded-lg hover:bg-brand-primary/90 transition-all font-montserrat font-semibold cursor-pointer inline-block">
                Seleccionar Archivos
              </span>
            </label>
          </div>

          {/* Preview Images */}
          {previewUrls.length > 0 && (
            <div className="mt-6">
              <h4 className="font-semibold text-slate-700 mb-3 font-montserrat">
                Imágenes seleccionadas ({selectedFiles.length})
              </h4>
              <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                {previewUrls.map((url, index) => (
                  <div key={index} className="relative group">
                    <img
                      src={url}
                      alt={`Preview ${index + 1}`}
                      className="w-full h-32 object-cover rounded-lg border border-slate-200"
                    />
                    <button
                      onClick={() => onRemoveFile(index)}
                      className="absolute top-2 right-2 p-1 bg-red-500 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                    >
                      <X className="w-4 h-4" />
                    </button>
                    <p className="text-xs text-slate-500 mt-1 truncate font-montserrat">
                      {selectedFiles[index].name}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="sticky bottom-0 bg-slate-50 border-t border-slate-200 p-6">
          <div className="flex gap-3">
            <button
              onClick={onClose}
              disabled={isUploading}
              className="flex-1 px-4 py-3 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300 transition-all font-montserrat font-semibold disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              onClick={onUpload}
              disabled={isUploading || selectedFiles.length === 0}
              className="flex-1 px-4 py-3 bg-brand-green text-white rounded-lg hover:bg-brand-green/90 transition-all font-montserrat font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isUploading ? 'Subiendo...' : `Subir ${selectedFiles.length} imagen(es)`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImageUploadModal;